import { render, staticRenderFns } from "./headlines-live.vue?vue&type=template&id=67c9c17c&scoped=true&"
import script from "./headlines-live.vue?vue&type=script&lang=js&"
export * from "./headlines-live.vue?vue&type=script&lang=js&"
import style0 from "./headlines-live.vue?vue&type=style&index=0&id=67c9c17c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9c17c",
  null
  
)

export default component.exports